var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 28.0038C2.66583 26.2787 3.08404 24.5793 3.88479 23.0513C4.68554 21.5234 5.84493 20.2124 7.26355 19.2309C8.68218 18.2493 10.3177 17.6265 12.0299 17.4158C13.742 17.2051 15.4797 17.4128 17.094 18.0211",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5033 22.1708C29.0345 21.6397 29.3328 20.9193 29.3328 20.1681C29.3328 19.417 29.0345 18.6966 28.5033 18.1655C27.9722 17.6343 27.2518 17.3359 26.5006 17.3359C25.7495 17.3359 25.0291 17.6343 24.498 18.1655L19.1513 23.5148C18.8343 23.8316 18.6023 24.2233 18.4767 24.6535L17.3607 28.4801C17.3272 28.5949 17.3252 28.7165 17.3548 28.8323C17.3845 28.948 17.4447 29.0537 17.5292 29.1382C17.6138 29.2227 17.7194 29.283 17.8352 29.3126C17.951 29.3423 18.0726 29.3403 18.1873 29.3068L22.014 28.1908C22.4442 28.0652 22.8358 27.8331 23.1527 27.5161L28.5033 22.1708Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3327 17.3333C17.0146 17.3333 19.9993 14.3486 19.9993 10.6667C19.9993 6.98477 17.0146 4 13.3327 4C9.65078 4 6.66602 6.98477 6.66602 10.6667C6.66602 14.3486 9.65078 17.3333 13.3327 17.3333Z",
    stroke: "currentcolor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8438b56aa7b204aacb32c66e35442ea9.svg";
export { ForwardRef as ReactComponent };